import langFaq from './langs/langFaq';

const FaqLangs = [langFaq];

export default FaqLangs;
